module.exports = __webpack_public_path__ + "static/facebook_add_calendar-7e6beb74115ca32d1924f9028abbc7b4.png";